import { Panel } from '$tablet-app/src/app/components/Panel';
import { ChecklistModel } from '@akin-home/checklists';
import { Text, TextProps } from '@akin-home/text/native';
import { colors } from '@akin-home/theme';
import React, { FC } from 'react';
import { TouchableOpacity } from 'react-native';
import styled from 'styled-components/native';
import { ChecklistPanel } from '../../ChecklistPanel';
import { ColumnDataType } from './types';

interface ColumnProps {
  columnData: ColumnDataType;
  list: ChecklistModel[] | undefined;
  onNewPress: () => any;
}

const ChecklistColumn: FC<ColumnProps> = (props) => {
  const { columnData, list, onNewPress } = props;

  return (
    <Column>
      <TouchableOpacity onPress={onNewPress}>
        <ColumnTitle color={columnData.titleColor}>
          {columnData.title}
        </ColumnTitle>
        <ColumnSubtitle>{columnData.subtitle}</ColumnSubtitle>
      </TouchableOpacity>

      {list?.length ? (
        list?.map((list) => (
          <ChecklistPanel
            style={{ backgroundColor: columnData.backgroundColor }}
            key={list.id}
            checklist={list}
          />
        ))
      ) : (
        <ChecklistPlaceholder onPress={onNewPress}>
          <Text weight="semibold">
            Press here to create {columnData.typeLabel.toLowerCase()}
          </Text>
        </ChecklistPlaceholder>
      )}
    </Column>
  );
};

const ColumnTitle = (props: TextProps) => (
  <Text variant="h2" weight="semibold" {...props} />
);

const ColumnSubtitle = (props: TextProps) => (
  <Text weight="semibold" color={colors.neutral[70]} {...props} />
);

const Column = styled(Panel)`
  flex: 1;
  padding: 20px;
  elevation: 1;
  gap: 20px;
`;

const ChecklistPlaceholder = styled.TouchableOpacity`
  border-radius: 20px;

  margin-top: 16px;
  padding: 16px;

  height: 200px;

  border-width: 2px;
  border-color: darkgrey;
  border-style: dashed;

  align-items: center;
  justify-content: center;
`;

export default ChecklistColumn;
